import {Component, Inject, OnInit} from '@angular/core';
import {BlockUI, NgBlockUI} from "../../../ngx-blockui/decorators/block-ui.decorator";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import {AppService} from "../../app.service";
import {EntityService} from "../../_core/entity.service";
import {ExpayService} from "../../_services/expay.service";
import {PaymentsService} from "../../_services/payment.serice";

import * as _ from "lodash";

@Component({
    selector: 'app-wallet-dialog',
    templateUrl: './wallet-dialog.component.html',
    styleUrl: './wallet-dialog.component.scss',
    standalone: false
})
export class WalletDialogComponent implements OnInit {
	@BlockUI() blockUI: NgBlockUI;

	parametersObservable: any;

	paymentMethods = this.appService.regionArgs.walletPMS;
	updatePassword = false;
	updateWallet = false;
	step = 'general';
	loading = true;

	userDetails: any = {
		name: '',
		email: '',
		phone: '',
		wallet: {
			payments: []
		},
	};

	ccinfo: any = {
		paymentType: "",
		type: undefined
	};

	constructor(
		public appService: AppService,
		public entityService: EntityService,
		public expayService: ExpayService,
		public paymentService: PaymentsService,
		public dialogRef: MatDialogRef<WalletDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
	) { }

	ngOnInit() {
		let that = this;
		let step = this.data.step;
		if (step) this.step = step;

		this.blockUI.start();
		this.entityService.getUserInfo(true)
			.then(response => {
				that.loading = false;
				that.userDetails = _.cloneDeep(response);
				if (!this.userDetails.wallet.payments.length) this.step = "addpm";

			}).catch(e => {

		}).finally(o => {
			this.blockUI.stop();
		});
	}

	pmDefaultChanged(pm) {
		if (pm.isDefault) return;
		this.userDetails.defaultWalletPayment = pm._id;
		_.each(this.userDetails.wallet.payments, _pm => {
			if (_pm != pm) _pm.isDefault = false;
			else _pm.isDefault = true;
		});
		this.updateAccount(true);
	}

	updatePasswordChanged() {
		delete this.userDetails.oldPassword;
		delete this.userDetails.newPassword;
	}

	updateAccount(silent?) {
		this.blockUI.start();
		let that = this;
		this.entityService.updateAccount(this.userDetails)
			.then(response => {
				if (!silent) {
					that.appService.toastr('MESSAGES.saved_successfully', { type: 'success' });
				}
				return that.refreshWallet()
					.then(() => {
						that.updatePasswordChanged();
						that.updatePassword = false;
						that.updateWallet = false;
						//that.cancel();
					});
			}).catch(() => {
			//that.blockUI.stop();
		}).then(o => {
			this.blockUI.stop();
		})
	}

	paymentMethodChanged() {
		this.ccinfo = { paymentType: this.ccinfo.paymentType };
		if (this.ccinfo.paymentType == 'creditCard') this.saveWalletPaymentInCreditGuard();
		if (this.ccinfo.paymentType == 'tabit') this.saveWalletPaymentInTabit();
	}

	addSinglePM() {
		if (this.paymentMethods.length > 1) {
			this.step = 'addpm';
			return;
		}
		switch (this.paymentMethods[0]) {
			case 'adyen':
				this.blockUI.start();
				return this.entityService.servicePost({
					url: `/online-shopper/customers/current/wallet/setup`,
					data: {
						paymentType: 'adyen'
					}
				}).then(res => {
					return this.expayService.showAdyenDialog({isAddToWallet: true}, res, {  }).then((response: any) => {

						switch (response?.status) {
							case 'pending':
								this.appService.alert({
									content: this.appService.translate('EX_PAYMENT.wallet_add_pending')
								});
								break;
							case 'error':
								this.appService.alert({
									title: this.appService.translate('error_title'),
									content: this.appService.translate('error_general')
								});
								break;

						}

					});
				}).finally(() => {
					this.blockUI.stop();
				});
		}
	}



	addPM(payment?: any) {
		this.blockUI.start();
		const paymentToSave = payment || this.ccinfo;
		return this.entityService.addPaymentMethodToWallet(paymentToSave)
			.then(() => {
				this.appService.toastr('MESSAGES.saved_successfully', { type: 'success' });
				return this.refreshWallet()
					.then(() => {
						this.step = 'general';
						this.ccinfo = {
							paymentType: "creditCard",
							type: undefined
						};
					});
			}).catch(err => {
				throw err;
			}).then(o => {
				this.blockUI.stop();
			})
	}

	deletePM(pm, ev?) {
		if (ev) ev.stopPropagation();
		let that = this;
		this.appService.confirm({ content: 'MESSAGES.Q_REMOVE_CARD' }).then(response => {
			that.blockUI.start();

			this.entityService.removePaymentFromWallet(pm._id).then(response => {
				that.appService.toastr('MESSAGES.deleted_successfully', { type: 'success' });
				return that.refreshWallet();
			}).catch(() => {

			}).then(o => {
				this.blockUI.stop();
			})
		}).catch(err => {

		});
	}

	refreshWallet() {
		let that = this;
		that.blockUI.start();
		return this.entityService.getUserWallet()
			.then(response => {
				that.userDetails = _.cloneDeep(response);
				console.log(response);
			}).catch(e => {

			}).then(o => {
				this.blockUI.stop();
			})
	}

	public saveWalletPaymentInCreditGuard(args?: any) {
		const that = this;
		this.appService.startBlock();
		const baseURL = document.location.origin + "/assets/expayment_ret.html?r=";
		const amount = args?.amount || 100;
		const direction = this.appService.locale == 'he-IL' ? 'rtl' : 'ltr';
		const uiLang = this.appService.locale == 'he-IL' ? 'heb' : 'eng';
		const textAlign = direction == 'rtl' ? 'right' : 'left';
		const paymentType = 'creditGuard';
		const iframeConfigurations = '{'
			+'   "uiCustomData":{'
			+'                   "uiLang": "' + uiLang + '", '
			+'                   "customStyle":"body {direction:' + direction + '; text-align:' + textAlign + '} #card-number, #cvv, .cg-message-input {direction:ltr; text-align:' + textAlign + '} #cg-ghost-btns {text-align: center !important;} #cg-tx-info {display: none !important;}",'
			+'                   "customText": {'
			// +'                                  "cg-popup-p":"' + this.appService.translate('EX_PAYMENT.popup-description') + '",'
			+'                                  "cg-popup-title": "' + this.appService.translate('EX_PAYMENT.wallet-popup-title') + '",'
			+'                                  "cg-sp-desc":"' + this.appService.translate('EX_PAYMENT.description') + '",'
			+'                                  "cg-submit-btn":"' + this.appService.translate('EX_PAYMENT.save') + '",'
			+'                                  "cg-form-title":"' + this.appService.translate('EX_PAYMENT.form-title') + '",'
			+'                                  "cg-clear":"' + this.appService.translate('EX_PAYMENT.clear') + '",'
			+'                                  "label-card-number":"' + this.appService.translate('EX_PAYMENT.credit_card_number') + '",'
			+'                                  "label-expYear": "' + this.appService.translate('EX_PAYMENT.expiration') + '",'
			+'                                  "cg-cancel":"' + this.appService.translate('EX_PAYMENT.cancel') + '",'
			+'                                  "cg-key-currency":"' + this.appService.translate('EX_PAYMENT.currency') + '",'
			+'                                  "cg-pd-title":"' + this.appService.translate('EX_PAYMENT.transaction_details') + '",'
			+'                                  "cg-amount-title":"' + this.appService.translate('EX_PAYMENT.total_amount') + '",'
			+'                                  "cg-popup-button":"' + this.appService.translate('EX_PAYMENT.click_here') + '"'
			+'                                 },'
			+'                   "paymentMethods": [{ "hidden": true, "type": "applepay" },{ "hidden": true, "type": "googlepay" }]'
			+'                  }'
			+'}'

		const initialRequestURL = '/online-shopper/customers/current/wallet/setup';
		const payload = { paymentType, amount, redirectUrlOnSuccess: `${baseURL}success`, iframeConfigurations };

		// Wallet payment - try to open iframe
		this.appService.logTemplate("walletPayment", { walletPayment: payload }, "Wallet payment - open iframe");

		return this.entityService.post(
			initialRequestURL,
			payload
		).then(setupResponse => {
			// Wallet payment - got iframe link
			this.appService.logTemplate("walletPayment", { walletPayment: setupResponse }, "Wallet payment - got iframe link");
			// We need this flag in order to displat the X button on the payment dialog
			setupResponse.addToWallet = true;

			this.expayService.showCreditGuardDialog(setupResponse)
				.then((res: any) => {
					if (res?.mode == 'success') {
						// Wallet payment - Got token from CG
						this.appService.logTemplate("walletPayment", { walletPayment: res }, "Wallet payment - got token from CG");

						const payload = {
							ownerName: this.appService.user?.loyaltyCustomer?.FirstName,
							paymentType: 'creditGuard',
							providerInfo: {
								providerTransactionId: res.transactionId
							}
						};

						// Wallet payment - Start of J5 payment
						this.appService.logTemplate("walletPayment", { walletPayment: payload }, "Wallet payment - trying a J5 in ROS");

						this.addPM(payload)
							.then(res => {
								// Wallet payment - Successful transaction (saved payment)
								this.appService.logTemplate("walletPayment", { walletPayment: payload }, "Wallet payment - trying a J5 in ROS");

								// Reset the paymnet type field
								that.setInitialCCInfo();

								handleStopBlock(res, false);
							}).catch(err => {
							handleStopBlock(err);
						})
					} else {
						handleStopBlock(res, false);
					}
				}).catch(err => {
				// If user pressed X, we just want to close the dialog
				const isError = err.type != 'CANCELED';
				handleStopBlock(err, isError);
			});
		}).catch(err => {
			handleStopBlock(err);
		});

		function handleStopBlock(response, ifError: boolean = true) {
			that.appService.stopBlock();
			console.debug(response);

			that.setInitialCCInfo();

			if (ifError) {
				// Wallet payment - Error in saving wallet payment
				that.appService.logTemplate("walletPaymentError", { walletPayment: response }, "Wallet payment - Error saving wallet payment");

				const dialogText = response?.error?.code == 409142 ? 'EX_PAYMENT.error_wallet_credentials' : 'EX_PAYMENT.error_client_credentials';
				that.appService.alert({ "content": dialogText })
					.finally(() => {
						that.appService.stopBlock();
					});
			}
		}
	}

	public async saveWalletPaymentInTabit() {
		const paymentType = 'tabit';

		this.appService.startBlock();
		try {
			this.appService.logTemplate(
				'Tabit Gateway Wallet payment - open iframe',
				{walletPayment: {paymentType}}
			);


			const baseURL = document.location.origin + '/assets/expayment_ret.html?r=';

			const setupRes = await this.entityService.post('/online-shopper/customers/current/wallet/setup', {
				paymentType,
				config: {
					appearance: {
						showSuccessPage: false,
						showErrorPage: false,
						language: this.appService.locale,
					},
					communication: {
						successUrl: `${baseURL}success`,
						errorUrl: `${baseURL}error`,
						cancelUrl: `${baseURL}cancel`,
					},
				},
			});

			this.appService.logTemplate(
				'Tabit Gateway Wallet payment - got iframe link',
				{walletPayment: setupRes}
			);

			const dialogRes = await this.expayService.showTabitPaymentDialog({}, setupRes);
			if (dialogRes?.mode !== 'success') {
				this.setInitialCCInfo();
				this.appService.stopBlock();
				return;
			}

			this.appService.logTemplate(
				'Tabit Gateway Wallet payment - got token',
				dialogRes,
			);

			const walletPayload = {
				ownerName: this.appService.user?.loyaltyCustomer?.FirstName,
				paymentType,
				providerInfo: {
					providerTransactionId: dialogRes.transactionId,
				},
			};

			this.appService.logTemplate(
				'Tabit Gateway Wallet payment - trying a J5 in ROS',
				{walletPayload}
			);

			await this.addPM(walletPayload);

			this.appService.logTemplate(
				'Tabit Gateway Wallet payment - saved successfully',
				{ walletPayload }
			);
		} catch (err) {
			this.appService.logTemplate(
				'Tabit Gateway Wallet payment - Error saving wallet payment',
				{walletPayment: err}
			);

			this.appService.alert({
				content: this.appService.translate('error_client_credentials'),
			});
		}
		this.appService.stopBlock();
	}

	setInitialCCInfo() {
		this.ccinfo = {
			paymentType: "",
			type: undefined
		};
	}
}
